import { render, staticRenderFns } from "./TkStaticHotelPlanInfo.vue?vue&type=template&id=7957afdc&"
import script from "./TkStaticHotelPlanInfo.vue?vue&type=script&lang=js&"
export * from "./TkStaticHotelPlanInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports